import { useCallback, useContext, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { handleLogout } from 'app/store/auth/asyncThunk';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { logoutProfile } from 'src/app/api/profile';
import { BootstrapContext } from 'src/app/bootstrap/BootstrapContext';

const IconBadge = styled('div')(({ theme }) => ({
  width: '20rem',
  aspectRatio: 5 / 1,
}));

function SignOutPage() {
  const Dispatch = useDispatch();

  const { initializeSession } = useContext(BootstrapContext);

  const handleKillSession = useCallback(async () => {
    try {
      await Dispatch(handleLogout({ _request: logoutProfile })).unwrap();
      const result = await initializeSession();
      console.log('initialize session result =>', result);
    } catch (err) {
      console.log(err);
    }
  }, [Dispatch, initializeSession]);

  useEffect(() => {
    const logoutTimer = setTimeout(() => {
      handleKillSession();
      clearTimeout(logoutTimer);
    }, 1000);
  }, []);

  return (
    <div className="flex flex-col flex-auto items-center sm:justify-center min-w-0">
      <Paper
        className="flex flex-col items-center w-full sm:w-auto min-h-full sm:min-h-auto rounded-0 py-32 px-16 sm:p-48 sm:rounded-2xl sm:shadow"
        style={{ maxWidth: '600px', minWidth: '300px', width: '100%' }}
      >
        <IconBadge>
          <img src="assets/images/brands/brand-extended-colored-001.svg" alt="logo de biometrics" />
        </IconBadge>

        <div className="mt-32 text-5xl font-extrabold flex justify-center items-center">
          <Link component={RouterLink} to="/sign-in">
            ¡Has cerrado sesión!
          </Link>
        </div>
      </Paper>
    </div>
  );
}

export default SignOutPage;
